module.exports = __webpack_public_path__ + "img/3.efe5d8e2.jpeg";